'use client';

import Logo from '@/components/Logo';
import { getMessages, localeDefault } from '@/lib/l18n';

export type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

// Next 14 doesn't load global-error's imported CSS when the root layout throws, so styles are inline.
const styles = `
@font-face {
  font-family: Meridian Regular;
  src: url(/fonts/Meridian/meridian-regular.woff2) format('woff2'),
    url(/fonts/Meridian/meridian-regular.woff) format('woff');
  font-display: swap;
}
* { box-sizing: border-box; }
body {
  margin: 0;
  min-height: 100vh;
  background: #000000;
  color: #FFFFFF;
  font-family: 'Meridian Regular', sans-serif;
}
.error-inner { max-width: 1440px; margin: 0 auto; padding: 32px 16px; }
.error-logo { color: inherit; display: inline-block; }
.error-main { max-width: 800px; margin: 0 auto; padding: 96px 0; }
.error-main h1 { font-size: clamp(2.5rem, 6vw, 3.75rem); font-weight: 300; line-height: 1.1; margin: 0 0 32px; }
.error-main p { font-size: clamp(1.25rem, 2.5vw, 1.625rem); line-height: 1.3; margin: 0 0 40px; }
.error-actions { display: flex; flex-wrap: wrap; gap: 24px; }
.error-actions a, .error-actions button {
  font: inherit;
  font-size: 1.125rem;
  padding: 14px 18px;
  border: 0;
  border-radius: 0;
  background: #FFA400;
  color: #000000;
  text-decoration: none;
  cursor: pointer;
}
.error-actions a:hover, .error-actions button:hover { background: #FFC32B; }
`;

export default function GlobalError({ reset }: GlobalErrorProps) {
  const t = getMessages(localeDefault).error;

  return (
    <html lang={localeDefault}>
      <head>
        <style dangerouslySetInnerHTML={{ __html: styles }} />
      </head>
      <body>
        <div className="error-inner">
          <header>
            <a href="/" aria-label={t.home} className="error-logo">
              <Logo />
            </a>
          </header>
          <main className="error-main">
            <h1>{t.title}</h1>
            <p>{t.summary}</p>
            <div className="error-actions">
              <button type="button" onClick={reset}>
                {t.retry}
              </button>
              <a href="/">{t.home}</a>
            </div>
          </main>
        </div>
      </body>
    </html>
  );
}
